import axios from "axios";
import { getTransactionId } from "./transactionId";

let csrfTokenPromise = null;

export const getCSRFToken = (signal) => {
  if (!csrfTokenPromise) {
    csrfTokenPromise = axios.request({
      method: "GET",
      url: `/api/GetToken?_=${Date.now()}`,
      withCredentials: true,
      signal,
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        "X-Transaction-ID": getTransactionId(),
      },
    });
  }

  return csrfTokenPromise;
};